import React from "react";
import classNames from "classnames";
import "./style.scss";
type Props = {
  className?: string;
  disabled?: boolean;
  value: true | false | "minus";
  onChange: (value: boolean) => void;
};
export const TableCheckbox: React.FC<Props> = ({
  className,
  disabled = false,
  value = false,
  onChange = () => {},
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
  };
  return (
    <label
      className={classNames(
        "table-checkbox",
        { minus: value === "minus" },
        className,
      )}
    >
      <input
        type="checkbox"
        aria-label="Select row"
        checked={value === true}
        onChange={handleChange}
        disabled={disabled}
      />
      <span></span>
    </label>
  );
};
